import { Constants, SyntheticVoiceEngine } from "@ambifi/ambifi-synthetic-voice";
// import simulateUtteranceFindReplace from '../constants/utteranceFindReplaceSimulate';
import { deepMerge } from "baobab/dist/helpers";
// import { NativeModules } from 'react-native';
// import SpeechRecognitionModuleManager from "react-native-keen-asr";
import _ from "lodash";
import { getUrlForValue } from "../actions/drive";
import { getVoiceForName, addSpeechRequest, stopSpeech } from "../actions/playerActions";
// import { startMiraListening, startMiraListeningWithDelay } from "../actions/ActionsListening";
import systemUtteranceFindReplace from "../constants/utteranceFindReplace";
import state from "../state";
import { evalItemText } from "../utils/runtimeApiUtils";
import { getCurrentItem } from "../utils/utils";
// Import the providers that will be registered with the SyntheticVoice engine
import AudioProvider from "./provider/audio";
import TtsProvider from "./provider/tts";

let striptags = require("striptags");

const SyntheticVoice = SyntheticVoiceEngine;
const SyntheticVoiceConstants = Constants;

// let MusicControl;
// if (state.get(["appCapabilities", "musicControlSupport"])) {
// 	MusicControl = require("react-native-music-control").default;
// }

const removeMd = require("remove-markdown");

//var SpeechRecognitionModuleManager = NativeModules.KeenAsr;

// let firstTime = true;

let sanitizedSpeechTextCache = {};

function speed(kias, mph, x, type) {
	let stripStartSquare = x.substring(7);
	let stripEndSquare = stripStartSquare.substring(0, stripStartSquare.length - 1);
	let speeds = stripEndSquare.split(";");

	if (type === "MPH") {
		return speeds[1] + " " + mph;
	} else {
		return speeds[0] + " " + kias;
	}
}

// function replaceArrayOfStrings(string, find, replace) {
// 	let replaceString = string;
// 	let regex;
// 	for (let i = 0; i < find.length; i++) {
// 		regex = new RegExp(find[i], "g");
// 		replaceString = replaceString.replace(regex, replace[i]);
// 	}
// 	return replaceString;
// }

function replaceStringsUsingMap(string, replaceMap) {
	let replaceString = string;
	let regex;

	// Need to loop through map
	for (let key in replaceMap) {
		regex = new RegExp(key, "g");
		replaceString = replaceString.replace(regex, replaceMap[key]);
	}

	return replaceString;
}

function fixUtterance(utterance) {
	// console.log(DeviceInfo.getManufacturer() + "; " + DeviceInfo.getModel());

	const ttsPhonetics = _.cloneDeep(state.get(["orgPreferences","tts-phonetics","ttsPhoneticsCompiled"]));

	let systemMap = ttsPhonetics ? ttsPhonetics : systemUtteranceFindReplace;

	console.log("*** System Map: " + JSON.stringify(systemMap));

	// Need to get from state any find replace maps for logged in user
	// May get them from organization level
	// May get the from activity level
	// Need to merge all starting with system, then organization, then activity, then platform, then manufacturer, then specific model

	// Simulate now
	//var findReplaceMap = simulateUtteranceFindReplace;

	//var srcMerge = deepmerge(systemMap, findReplaceMap);
	let srcMerge = systemMap;

	let dstMerge = srcMerge.system;
	dstMerge = deepMerge(dstMerge, srcMerge.organization);
	dstMerge = deepMerge(dstMerge, srcMerge.activity);
	dstMerge = deepMerge(dstMerge, srcMerge.platforms["web"]);
	// dstMerge = deepMerge(dstMerge, srcMerge.manufacturers[DeviceInfo.getManufacturer()]);
	// dstMerge = deepMerge(dstMerge, srcMerge.models[DeviceInfo.getModel()]);

	let strip = striptags(utterance);
	let remove = removeMd(strip);
	let fix = replaceStringsUsingMap(remove, dstMerge);

	return fix;
}

class SyntheticVoiceApi {
	constructor() {
		console.log("SyntheticVoiceApi: CONSTRUCTOR");
		//if (Platform.OS === 'ios') {
		this.ttsStart = this.speechStart.bind(this);
		this.ttsFinish = this.speechEnd.bind(this);
		// console.log(Test,Constants, SyntheticVoiceEngine);
		SyntheticVoice.registerVoiceProvider(SyntheticVoiceConstants.SYNTHETIC_VOICE_TYPE_AUDIO, AudioProvider);
		SyntheticVoice.registerVoiceProvider(SyntheticVoiceConstants.SYNTHETIC_VOICE_TYPE_TEXT_TO_SPEECH, TtsProvider);
		// Tts.setDucking(true);
		// console.log("About to register even listeners", SyntheticVoice);
		SyntheticVoice.addEventListener(SyntheticVoiceConstants.EVENT_TYPE_SPEECH_TRANSACTION_START, this.speechStart.bind(this));
		SyntheticVoice.addEventListener(SyntheticVoiceConstants.EVENT_TYPE_SPEECH_TRANSACTION_FINISH, this.speechEnd.bind(this));
		//}

		this.speaking = false;

		this.currentUtteranceId = 0;
		this.utteranceId = 1;

		this.utterances = [];
	}

	speechStart() {
		state.set(["miraSpeaking"], true);

		// console.log("in ttsStart");
		if (this.utterances !== null && this.utterances.length !== 0) {
			this.currentUtteranceId = this.utterances[0].utteranceId;
			global.TtsEvents.emit("started", this.utterances[0].itemLocation);
			// this.suspendRecognition();
		}
	}

	speechEnd() {
		// console.log("ttsEnd: " + JSON.stringify(transaction));

		if (this.utterances !== null && this.utterances.length !== 0) {
			// console.log(JSON.stringify(this.utterances));
			let utterance = this.utterances.shift();
			// console.log("ttsFinish ", utterance);

			global.TtsEvents.emit("finished", utterance.itemLocation);
			// this.resumeRecognition();
		}

		state.set(["miraSpeaking"], false);
	}

	// suspendRecognition() {
	// 	this.speaking = true;
	// 	state.set(["miraSpeaking"], true);

	// 	let item = Utils.getCurrentItem(state);
	// 	let caption = "";
	// 	if (item !== null) {
	// 		caption = removeMd(striptags(item.label1)) + (item.label2 !== "" ? " - " + removeMd(striptags(item.label2)) : "");
	// 	}

	// 	if (state.get(["appCapabilities", "musicControlSupport"])) {
	// 		//  setTimeout(function () {
	// 		if (caption !== "") {
	// 			Actions.setNowPlayingCaption(caption);
	// 		}
	// 		MusicControl.updatePlayback({
	// 			state: MusicControl.STATE_PLAYING,
	// 			elapsedTime: 0
	// 		});
	// 		//  },300);
	// 	}

	// 	Actions.setDebugConsoleText("suspendRecognition");
	// 	if (Utils.isAppCapabilityActive("speechRecognition")) {
	// 		if (state.get(["listening"])) {
	// 			if (!state.get(["interruptMira"])) {
	// 				SpeechRecognitionModuleManager.suspendRecognition();
	// 				startMiraListening();
	// 			} else {
	// 				startMiraListening();
	// 			}
	// 		}
	// 	}
	// }

	// resumeRecognition() {
	// 	this.speaking = false;
	// 	state.set(["miraSpeaking"], false);

	// 	Actions.setDebugConsoleText("resumeRecognition");

	// 	if (state.get(["appCapabilities", "musicControlSupport"])) {
	// 		setTimeout(function () {
	// 			MusicControl.updatePlayback({
	// 				state: MusicControl.STATE_PAUSED,
	// 				elapsedTime: 0
	// 			});
	// 		}, 300);
	// 	}
	// 	if (Utils.isAppCapabilityActive("speechRecognition")) {
	// 		if (state.get(["listening"])) {
	// 			if (!state.get(["interruptMira"])) {
	// 				SpeechRecognitionModuleManager.resumeRecognition();
	// 			}

	// 			startMiraListeningWithDelay();
	// 		}
	// 	}
	// }

	isSpeaking() {
		return SyntheticVoice.isSpeaking();
	}
	/*
		setInterruptMira() {
			if (Platform.OS === 'ios') {
				if (state.get(["interruptMira"])) {
					Tts.removeEventListener('tts-start', this.suspendRecognition);
					Tts.removeEventListener('tts-finish', this.resumeRecognition);
				} else {
					Tts.addEventListener('tts-start', this.suspendRecognition);
					Tts.addEventListener('tts-finish', this.resumeRecognition);
				}
			}
		}  
	    
		removeRecognitionListeners() {
			if (state.get(["interruptMira"])) {
				Tts.removeEventListener('tts-start', this.suspendRecognition);
				Tts.removeEventListener('tts-finish', this.resumeRecognition);
			}        
		}
	*/
	setDefaultSpeed(speed) {
		SyntheticVoice.setDefaultRate(speed);
	}

	compareVoices(a, b) {
		// Use toUpperCase() to ignore character casing
		const idA = a.id.toUpperCase();
		const idB = b.id.toUpperCase();

		let comparison = 0;
		if (idA > idB) {
			comparison = 1;
		} else if (idA < idB) {
			comparison = -1;
		}
		return comparison;
	}

	setVoices(tree) {
		let arrVoices = [];
		SyntheticVoice.getVoices().then(voices => {
			// arrVoices.push({
			// 	id: "com.apple.ttsbundle.siri_female_en-US_compact",
			// 	lang: "en-US",
			// 	label: "Siri Female (en-US)"
			// });

			// arrVoices.push({
			// 	id: "com.apple.ttsbundle.siri_male_en-US_compact",
			// 	lang: "en-US",
			// 	label: "Siri Male (en-US)"
			// });

			for (let i = 0; i < voices.length; i++) {
				let voice = {
					id: voices[i].id,
					lang: voices[i].language,
					label: voices[i].name + " (" + voices[i].language + ")"
				};
				arrVoices.push(voice);
			}
			arrVoices.sort(this.compareVoices);

			tree.set(["voices", "list"], arrVoices);
			// console.log("Voices:", voices);
		});
	}

	setDefaultLanguage(lang) {
		SyntheticVoice.setDefaultLanguage(lang);
	}

	setDefaultVoice(voice) {
		// if (Platform.OS === 'ios') {
		let _voice = voice;
		if (_.isString(voice)) {
			// It's the name of the voice
			_voice = getVoiceForName(voice);
		}
		console.log("Set default voice", voice, _voice);
		if (_voice) {
			console.log("Set default voice", _voice);
			SyntheticVoice.setDefaultVoice(_voice);
		}
		// } 
	}

	getVoice(voice) {
		// if (Platform.OS === 'ios') {
		let _voice = voice;
		if (_.isString(voice)) {
			// It's the name of the voice
			_voice = getVoiceForName(voice);
		}
		return _voice;
	}

	clearSpeechCache() {
		sanitizedSpeechTextCache = {};
		// utteranceMapCache = {};
	}

	sanitizeForSpeech(text, cacheKey = null) {
		// Slip this if for some reason there is no text or it's not a String
		if (text && _.isString(text)) {

			if (cacheKey && sanitizedSpeechTextCache[cacheKey]) {
				// console.log("Sanitized version from cache", text, sanitizedSpeechTextCache[cacheKey]);
				return sanitizedSpeechTextCache[cacheKey];
			} else {
				text = evalItemText(getCurrentItem(state),text);

				// console.log("Need to sanitize", text);
				const units = state.get(["content"]).units;

				text = text.replace(/""/g, "");
				text = text.replace(/ kias| KIAS/g, units.knots);
				text = text.replace(/ °|º/g, " Degrees");
				if (state.get(["activity"])) {
					text = text.replace(/\[speed [^]+;[^]+\]/g, function myFunction(x) { return speed(units.knots, units.mph, x, state.get(["activity", "preferences", "speedType"])); });
				}

				text = fixUtterance(text);

				if (cacheKey) {
					sanitizedSpeechTextCache[cacheKey] = text;
				}
				//console.log("Sanitized", text);
				return text;
			}
		}
		return text;
	}

	getContentForEntityProp(item, prop = "label1", config) {
		console.log("SyntheticVoiceApi: getContentForItemProp: ", item, prop, config);
		let result = null;

		let _prop = prop;
		// if (_prop === "label1") {
		// 	_prop = "label";
		// }

		const text = item[_prop];
		const textAudio = item[`${prop}Audio`];
		const audioFileUrl = item[`${prop}AudioFile`];

		let ttsText = null;
		if (textAudio && !_.isEmpty(textAudio) && _.isString(textAudio) && textAudio !== "") {
			ttsText = textAudio;
		} else if (text && _.isString(text) && text !== "") {
			ttsText = text;
		}


		if (audioFileUrl && !_.isEmpty(audioFileUrl) && audioFileUrl !== "") {
			const audioResource = getUrlForValue(audioFileUrl);
			// console.log("SyntheticVoiceApi getAudioResourceURL", audioFileUrl, audioResource);
			result = SyntheticVoice.getAudioSpeechRequest(audioResource);
			result.fallback = null;
			if (ttsText) {
				result.fallback = SyntheticVoice.getTextToSpeechSpeechRequest(ttsText);
			}
		} else if (ttsText) {
			let _ttsText = ttsText;
			if (_ttsText && config.hasOwnProperty("suffix") && _.isString(config.suffix) && config.addSuffix && !_ttsText.toLowerCase().trim().endsWith(config.suffix.toLowerCase())) {
				_ttsText = `${_ttsText} ${config.suffix}`;
			}
			result = SyntheticVoice.getTextToSpeechSpeechRequest(_ttsText);
		}

		if (result && result.text) {
			// See if this needs sanitized
			// if (config.sanitize) {
			result.text = this.sanitizeForSpeech(result.text, `${item.guid}-${prop}`);
			// }
		}

		console.log("SyntheticVoiceApi: getContentForItemProp (result): ", result);
		return result;
	}

	/**
	 * Given an item and configuration this function will properly extract the content
	 * that should be spoken
	 * @param {*} item 
	 * @param {*} config 
	 */
	getContentForEntitySpeak(item, config = { prop: ["label"] }) {
		console.log("SyntheticVoiceApi: getContentForEntitySpeak: ", item, config);
		let speechConfigs = [];
		let props = [];
		const { prop } = config;
		if (!_.isArray(prop)) {
			props.push(prop);
		} else {
			props = prop;
		}
		if (item.hasOwnProperty("audio") && !_.isEmpty(item.audio) && item.audio !== "") {
			const url = getUrlForValue(item.audio);
			const speechRequest = SyntheticVoice.getAudioSpeechRequest(url, config);
			// Figure out a reasonable fallback if this fails
			const prop = _.first(props);
			if (prop) {
				const speechConfig = this.getContentForEntityProp(item, prop, config);
				if (speechConfig && !speechRequest.fallback) {
					speechRequest.fallback = speechConfig;
				}
			}
			speechConfigs.push(speechRequest);
		} else {

			props.forEach(prop => {
				const speechConfig = this.getContentForEntityProp(item, prop, config);
				if (speechConfig) {
					speechConfigs.push(speechConfig);
				}
			});
		
			if (config.extraText) {
				let _extraText = [];
				if (!_.isArray(config.extraText)) {
					_extraText.push(config.extraText);
				} else {
					_extraText = config.extraText;
				}
				// console.log("GOT EXTRA TEXT");
				_extraText.forEach(_text => {
					// console.log("GOT EXTRA TEXT", _text);
					speechConfigs.push(SyntheticVoice.getTextToSpeechSpeechRequest(_text, config));
				});
			}
		}
		return speechConfigs;
	}

	speakCurrentItem(config) {
		console.log("SyntheticVoiceApi: speakCurrentItem: ", config);
		// console.log("SyntheticVoiceApi: speakCurrentItem");
		// const selectedListIndex = start.get(["activity", "selectedListIndex"]);
		const listIndex = state.get(["activity", "selected", "listIndex"]);
		const sectionIndex = state.get(["activity", "selected", "sectionIndex"]);
		const itemIndex = state.get(["activity", "selected", "itemIndex"]);
		const selectedItem = state.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		if (selectedItem) {
			this.speakItem(selectedItem, config, null, {
				listIndex,
				sectionIndex,
				itemIndex
			});
		}
	}

	speakSection(section, config = { prop: ["name"] }) {
		console.log("SyntheticVoiceApi: speakSection: ",section, config);
		// console.log("SPEAK SECTION", new Error().stack);
		this.speakEntity(section, config);
	}

	speakList(list, config = { prop: ["name"] }) {
		console.log("SyntheticVoiceApi: speakList: ", list, config);
		this.speakEntity(list, config);
	}

	speakActivity(activity, config = { prop: ["name"] }) {
		console.log("SyntheticVoiceApi: speakActivity: ", activity, config);
		this.speakEntity(activity, config);
	}

	speakAudio(audioFileUrl, config = {}) {
		// console.log("SyntheticVoiceApi: speakAudio");
		const speechRequests = [];
		if (_.isArray(audioFileUrl)) {
			audioFileUrl.forEach(url => {
				speechRequests.push(SyntheticVoice.getAudioSpeechRequest(url, config));
			});
		} else {
			speechRequests.push(SyntheticVoice.getAudioSpeechRequest(audioFileUrl, config));
		}
		this.speak(speechRequests);
	}

	speakEntity(entity, config) {
		console.log("SyntheticVoiceApi: speakEntity", entity, config);
		const speechConfigs = this.getContentForEntitySpeak(entity, config);
		if (!_.isEmpty(speechConfigs)) {
			// console.log("SPEAK ENTITY", entity, config, speechConfigs);
			this.speak(speechConfigs);
		}
	}

	speakItem(item, config, itemIndex = null, itemLocation = null) {
		console.log("SyntheticVoiceApi: speakItem", item, config);
		const speechConfigs = this.getContentForEntitySpeak(item, config);
		if (!_.isEmpty(speechConfigs)) {
			this.speak(speechConfigs, itemIndex, itemLocation);
		}
	}

	speak(utterance, itemIndex = null, itemLocation = null, options={}) {
		// return;
		if (utterance === null || !state.get(["appPreferences", "voice","audio"])) {
			return;
		}

		console.log("SyntheticVoiceApi: speak: ", utterance);

		if (_.isString(utterance)) {
			utterance = this.sanitizeForSpeech(utterance, utterance.replace(" ","_"));
		}

		this.setDefaultSpeed(state.get(["appPreferences", "voice","speed"]));

		// Causes issues!
		// If Markdown then want to handle better
		// For now any ones that start with exlamation ignore
        /*
        if (utterance.startsWith("!") || utterance.startsWith("[")) {
            return;
        }
        */

		if (state.get(["appPreferences", "voice", "audio"])) {
			console.log("DO SPEAK");
			//var selectedListIndex = state.get(["activity","selected","listIndex"]);
			//var selectedSectionIndex = state.get(["activity","selected","sectionIndex"]);
			//var selectedItemIndex = state.get(["activity","selected","itemIndex"]);

			let checklistSuppressAudio = state.get(["activity", "suppressAudio"]);

			//var listSuppressAudio = typeof selectedListIndex != 'undefined' ? state.get(["activity","children",selectedListIndex,"suppressAudio"]) : false;
			//var sectionSuppressAudio = typeof selectedSectionIndex != 'undefined' ? state.get(["activity","children",selectedListIndex,"children",selectedSectionIndex,"suppressAudio"]) : false;
			//var itemSuppressAudio = typeof selectedSectionIndex != 'undefined' ? state.get(["activity","children",selectedListIndex,"children",selectedSectionIndex,"children",selectedItemIndex,"suppressAudio"]) : false;

			if (!checklistSuppressAudio) {
				console.log("NOT SUPRESSED AUDIO",utterance);
				let objItem = null;
				let objUtterance = null;
				if (itemIndex !== null) {
					let itemParts = itemIndex.split(";");
					objItem = {
						listIndex: Number(itemParts[0]),
						sectionIndex: Number(itemParts[1]),
						itemIndex: Number(itemParts[2])
					};
				}


				if (objItem === null) {
					addSpeechRequest(utterance, { delay: 0.0, options }, { itemIndex, itemLocation });
						// SyntheticVoice.speak(utterance, { delay: 0.0,options }, { itemIndex, itemLocation });
				} else {
					addSpeechRequest(utterance, { delay: state.get(["appPreferences", "itemDelay"], options) }, { itemIndex, itemLocation });
						// SyntheticVoice.speak(utterance, { delay: state.get(["appPreferences", "itemDelay"],options) }, { itemIndex, itemLocation });
					}

					objUtterance = {
						utteranceId: this.utteranceId++,
						utterance,
						itemIndex: objItem,
						itemLocation
					};
					// // console.log("Adding utterance: " + JSON.stringify(objUtterance));
					this.utterances.push(objUtterance);



			}
		}
	}

	doSpeak(...sr) {
		SyntheticVoice.speak(...sr);
	}

	speakNoPush(utterance) {
		stopSpeech();

		this.setDefaultSpeed(state.get(["appPreferences", "voice", "speed"]));

		let units = state.get(["content"]).units;

		utterance = utterance.replace(/""/g, "");
		utterance = utterance.replace(/ kias| KIAS/g, units.knots);
		utterance = utterance.replace(/ °|º/g, " Degrees");

		let utteranceSpeed = utterance.replace(/\[speed [^]+;[^]+\]/g, function myFunction(x) { return speed(units.knots, units.mph, x, state.get(["activity", "preferences", "speedType"])); });
		if (state.get(["appPreferences", "voice","audio"])) {
			let checklistSuppressAudio = state.get(["activity", "suppressAudio"]);

			if (!checklistSuppressAudio) {
				let fixedUtterance = fixUtterance(utteranceSpeed);

				// if (state.get(["appCapabilities", "musicControlSupport"])) {
				// 	MusicControl.updatePlayback({
				// 		state: MusicControl.STATE_PLAYING,
				// 		elapsedTime: 0
				// 	});
				// }
				addSpeechRequest(fixedUtterance, { delay: state.get(["appPreferences", "itemDelay"]) });
				// SyntheticVoice.speak(fixedUtterance, { delay: state.get(["appPreferences", "itemDelay"]) });

			}
		}
	}

	togglePauseResume() {
		if (state.get(["appState", "paused"])) {
			this.resume();
		} else {
			this.pause();
		}
	}

	pause(purgeUtterances = false) {
		if (state.get(["appPreferences", "voice", "audio"])) {
			stopSpeech();
			this.resumeRecognition();
			state.set(["appState", "paused"], true);

			if (purgeUtterances) {
				this.utterances = [];
			}
			global.TtsEvents.emit("paused");
		}

	}

	resume() {
		let self = this;
		if (state.get(["appPreferences", "voice","audio"])) {
			// this.suspendRecognition();

			// let itemIndex = 0;
			// Loop through section items
			this.utterances.forEach(function (item) {
				let utterance = item.utterance;
				let itemIndex = item.itemIndex;
				// if (itemIndex !== null) {
				// 	itemIndex = itemIndex.listIndex + ";" + itemIndex.sectionIndex + ";" + itemIndex.itemIndex;
				// }
				self.speakNoPush(utterance, itemIndex);
			});
			state.set(["appState", "paused"], false);
		}
	}

	stop() {
		stopSpeech();
	}

	doStop() {
		state.set(["miraSpeaking"], false);

		if (state.get(["appPreferences", "voice","audio"])) {
			SyntheticVoice.stop();
			// this.resumeRecognition();

			// if (this.utterances.length !== 0 && this.utterances[0].itemIndex !== null) {
			// 	const lastListIndex = this.utterances[0].itemIndex.listIndex;
			// 	const lastSectionIndex = this.utterances[0].itemIndex.sectionIndex;
			// 	setSelectedItem(state, lastListIndex, lastSectionIndex, 0, true);
			// }

			this.utterances = [];
		}
	}
}

export default new SyntheticVoiceApi();